(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-menu-button]').forEach(button => {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      const menu = document.getElementById(button.getAttribute('aria-controls'));
      if (!menu) return;
      let savedScroll = 0;
      let bodyStyle = '';
      let locked = false;
      let motionVersion = 0;
      let animations = [];
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      const menuLinks = [...menu.querySelectorAll('.lb-mobile-primary > a, .lb-mobile-secondary > a')];
      const cancelMotion = () => {
        motionVersion += 1;
        animations.forEach(animation => animation.cancel());
        animations = [];
      };
      const animate = (element, frames, options) => {
        const animation = element.animate(frames, {...options, fill: 'both'});
        animations.push(animation);
        return animation;
      };
      const restore = () => {
        if (!locked) return;
        locked = false;
        document.body.style.cssText = bodyStyle;
        document.documentElement.classList.remove('lb-menu-open');
        button.setAttribute('aria-expanded', 'false');
        window.scrollTo({top: savedScroll, behavior: 'instant'});
        if (button.getClientRects().length) button.focus({preventScroll: true});
      };
      const close = (immediate = false) => {
        if (!menu.open) { restore(); return; }
        if (menu.dataset.motion === 'closing' && !immediate) return;
        const opacity = getComputedStyle(menu).opacity;
        const linkStyles = menuLinks.map(element => ({opacity: getComputedStyle(element).opacity, transform: getComputedStyle(element).transform}));
        cancelMotion();
        const version = motionVersion;
        const finish = () => {
          if (version !== motionVersion) return;
          menu.close();
          delete menu.dataset.motion;
          cancelMotion();
          restore();
        };
        if (immediate || reducedMotion.matches || !menu.animate) { finish(); return; }
        menu.dataset.motion = 'closing';
        menuLinks.forEach((element, index) => animate(element, [linkStyles[index], {opacity: 0, transform: 'translateY(-6px)'}], {duration: 160, easing: 'ease-in-out'}));
        animate(menu, [{opacity}, {opacity: 0}], {duration: 180, easing: 'ease-in-out'}).finished.then(finish, () => {});
      };
      button.addEventListener('click', event => {
        if (menu.open) { close(); return; }
        savedScroll = window.scrollY;
        bodyStyle = document.body.style.cssText;
        locked = true;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${savedScroll}px`;
        document.body.style.width = '100%';
        document.documentElement.classList.add('lb-menu-open');
        document.documentElement.style.setProperty('--nav-hide', '0');
        button.setAttribute('aria-expanded', 'true');
        menu.showModal();
        menu.querySelector('[data-menu-close]').focus({preventScroll: true});
        cancelMotion();
        menu.dataset.motion = 'open';
        if (!reducedMotion.matches && event.detail !== 0 && menu.animate) {
          const version = motionVersion;
          menu.dataset.motion = 'opening';
          menuLinks.forEach((element, index) => animate(element, [{opacity: 0, transform: 'translateY(7px)'}, {opacity: 1, transform: 'translateY(0)'}], {duration: 260, delay: 20 + Math.min(index, 7) * 30, easing: 'cubic-bezier(.22,1,.36,1)'}));
          animate(menu, [{opacity: 0}, {opacity: 1}], {duration: 280, easing: 'cubic-bezier(.22,1,.36,1)'});
          Promise.all(animations.map(animation => animation.finished)).then(() => {
            if (version === motionVersion && menu.open) menu.dataset.motion = 'open';
          }, () => {});
        }
      });
      menu.querySelector('[data-menu-close]').addEventListener('click', event => close(event.detail === 0));
      menu.addEventListener('close', () => { if (!menu.open) { cancelMotion(); delete menu.dataset.motion; restore(); } });
      menu.addEventListener('cancel', event => { event.preventDefault(); close(true); });
      menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => close(true)));
      reducedMotion.addEventListener('change', () => {
        if (!reducedMotion.matches || !menu.open) return;
        if (menu.dataset.motion === 'closing') close(true);
        else { cancelMotion(); menu.dataset.motion = 'open'; }
      });
      const desktop = matchMedia('(min-width: 1200px)');
      desktop.addEventListener('change', event => { if (event.matches) close(true); });
      document.addEventListener('shopify:section:unload', event => { if (event.target.contains(button)) close(true); });
    });
    root.querySelectorAll('[data-gallery-src]').forEach(button => {
      if (button.dataset.bound) return; button.dataset.bound = 'true';
      button.addEventListener('click', () => { const image = button.closest('.lb-gallery').querySelector('.lb-main-image img'); image.removeAttribute('srcset'); image.src = button.dataset.gallerySrc; button.closest('.lb-thumbs').querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(b === button))); });
    });
    root.querySelectorAll('[data-quantity]').forEach(button => {
      if (button.dataset.bound) return; button.dataset.bound = 'true';
      button.addEventListener('click', () => { const input = button.parentElement.querySelector('input'); input.value = Math.max(1, Math.min(Number(input.max) || 99, (Number(input.value) || 1) + Number(button.dataset.quantity))); input.dispatchEvent(new Event('change', { bubbles: true })); });
    });
    root.querySelectorAll('[data-product-variants]').forEach(script => {
      if (script.dataset.bound) return; script.dataset.bound = 'true';
      const section = script.closest('section'); const select = section.querySelector('[data-variant-select]');
      if (!select) return;
      const variants = JSON.parse(script.textContent);
      const update = (changeVariant = false) => {
        const variant = variants.find(v => String(v.id) === select.value); if (!variant) return;
        section.querySelectorAll('[data-variant-plans]').forEach(group => {
          const active = group.dataset.variantPlans === select.value; group.hidden = !active; group.disabled = !active;
          if (active && !group.querySelector('input:checked')) { const first = group.querySelector('input'); if (first) first.checked = true; }
        });
        const checked = section.querySelector('[data-variant-plans]:not([hidden]) input:checked');
        const plan = variant.plans.find(p => String(p.id) === checked?.value);
        section.querySelector('[data-product-price]').textContent = plan?.price || variant.price;
        const compare = section.querySelector('[data-compare-price]'); compare.textContent = plan ? plan.compare : variant.compare; compare.hidden = !compare.textContent;
        const terms = section.querySelector('[data-plan-terms]');
        terms.textContent = plan ? [plan.description, plan.checkout + ' due at checkout.', plan.remaining_amount > 0 ? plan.remaining + ' remaining under the membership terms.' : ''].filter(Boolean).join(' ') : '';
        const add = section.querySelector('[data-add-button]'); add.disabled = !variant.available; add.textContent = variant.available ? 'Add to cart' : 'Sold out';
        if (changeVariant) {
          if (variant.image) { const image = section.querySelector('.lb-main-image img'); image.removeAttribute('srcset'); image.src = variant.image; }
          const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
        }
      };
      select.addEventListener('change', () => update(true));
      section.querySelectorAll('input[name="selling_plan"]').forEach(input => input.addEventListener('change', () => update()));
      update();
    });
    root.querySelectorAll('[data-lb-scroll]').forEach(button => {
      if (button.dataset.bound) return; button.dataset.bound = 'true';
      button.addEventListener('click', () => { const carousel = button.closest('[data-slot="carousel"]')?.querySelector('.lb-carousel'); if (carousel) carousel.scrollBy({ left: carousel.clientWidth * (button.dataset.lbScroll === 'next' ? 1 : -1), behavior: 'smooth' }); });
    });
    root.querySelectorAll('[data-slice-type="hero"]').forEach(hero => {
      if (hero.dataset.bound) return; hero.dataset.bound = 'true'; hero.style.position = 'relative';
      const videos = [...hero.querySelectorAll('video')]; if (!videos.some(v => v.getAttribute('src'))) return;
      const preference = matchMedia('(prefers-reduced-motion: reduce)');
      const mobile = matchMedia('(max-width: 479px)');
      const sync = () => videos.forEach(video => {
        if (preference.matches || document.hidden || getComputedStyle(video).display === 'none') video.pause();
        else video.play().catch(() => {});
      });
      preference.addEventListener('change', sync);
      mobile.addEventListener('change', sync);
      document.addEventListener('visibilitychange', sync);
      sync();
    });
  };
  init(); document.addEventListener('shopify:section:load', e => init(e.target));
  const announcement = document.querySelector('.lb-announcement'); if (!announcement) document.documentElement.style.setProperty('--banner-height', '0px');
  const home = document.body.classList.contains('template-index');
  if (home) { const updateHeader = () => { const hero = document.querySelector('[data-slice-type="hero"]'); const light = !!hero && hero.getBoundingClientRect().bottom > innerHeight * 0.1; document.documentElement.classList.toggle('nav-light', light); document.documentElement.classList.toggle('nav-dark', !light); }; updateHeader(); addEventListener('scroll', updateHeader, { passive: true }); }
})();
(() => {
  function initPolicies(root = document) {
    root.querySelectorAll('.lb-policy-tabs').forEach(list => {
      if (list.dataset.bound) return; list.dataset.bound = 'true';
      const tabs = [...list.querySelectorAll('[data-policy-tab]')];
      const activate = (tab, focus = false) => {
        tabs.forEach(t => { const selected = t === tab; t.setAttribute('aria-selected', String(selected)); t.tabIndex = selected ? 0 : -1; document.getElementById(t.getAttribute('aria-controls')).hidden = !selected; });
        if (focus) tab.focus();
      };
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', event => { let next = null; if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (i + 1) % tabs.length; if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (i + tabs.length - 1) % tabs.length; if (event.key === 'Home') next = 0; if (event.key === 'End') next = tabs.length - 1; if (next !== null) { event.preventDefault(); activate(tabs[next], true); } });
      });
      const requested = new URLSearchParams(location.search).get('page'); const selected = tabs.find(t => t.dataset.policyTab === requested) || tabs.find(t => t.getAttribute('aria-selected') === 'true') || tabs[0];
      if (selected) activate(selected);
    });
  }
  initPolicies();document.addEventListener('shopify:section:load', event => initPolicies(event.target));
})();
